export default {"src":"/_next/static/media/accordion-2.5379e47b.svg","height":390,"width":494,"blurWidth":0,"blurHeight":0};